/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
// idSlice.js
import { createSlice } from '@reduxjs/toolkit';


const initialState={
    selectedUsers:{
        data:[],
        selectedArr:[], 
        unselectedArr:[],
        isCheckedAll:true,
        searchVal:'',
        totalUsers:0
        
    }
    
}
const wellnessSlice = createSlice({
    name: 'selectedUsers',
    initialState: initialState,
    reducers: {
     
        toggleRowSelection: (state, action) => {

            let column=action.payload[0]
            const dataItems=action?.payload[1]?.map(item=>item._id)
            const selectAllofSearchOrCompleteList = action?.payload[2]
            const complete_list_or_searched_list = action?.payload[3]
            const isChecked = action?.payload[4]
            if(isChecked){
                if((complete_list_or_searched_list==='complete_list'&&!selectAllofSearchOrCompleteList)||(complete_list_or_searched_list==='searched_list'&&!selectAllofSearchOrCompleteList)){
                    state.selectedUsers.unselectedArr.includes(column)?state.selectedUsers.unselectedArr=state.selectedUsers?.unselectedArr?.filter(item=>item!==column):''
                    state.selectedUsers.selectedArr.push(column)
                }else if((complete_list_or_searched_list==='complete_list'&&selectAllofSearchOrCompleteList)||(complete_list_or_searched_list==='searched_list'&&selectAllofSearchOrCompleteList)){
                    state.selectedUsers.unselectedArr.includes(column)?state.selectedUsers.unselectedArr=state.selectedUsers.unselectedArr.filter(item=>item!==column):''
                    state.selectedUsers.selectedArr.push(column)
                }
            }
            
            else{
                if((complete_list_or_searched_list==='complete_list'&&!selectAllofSearchOrCompleteList)||(complete_list_or_searched_list==='searched_list'&&!selectAllofSearchOrCompleteList)){
                    state.selectedUsers.selectedArr.includes(column)?state.selectedUsers.selectedArr=state.selectedUsers?.selectedArr?.filter(item=>item!==column):''
                    state.selectedUsers.unselectedArr.push(column)
                }else if((complete_list_or_searched_list==='complete_list'&&selectAllofSearchOrCompleteList)||(complete_list_or_searched_list==='searched_list'&&selectAllofSearchOrCompleteList)){
                    state.selectedUsers.selectedArr.includes(column)?state.selectedUsers.selectedArr=state.selectedUsers.selectedArr.filter(item=>item!==column):''
                    state.selectedUsers.unselectedArr.push(column)
                }
                
            }
            if(complete_list_or_searched_list==='complete_list'){
                if((state.selectedUsers.selectedArr.length===0&&state.selectedUsers.unselectedArr.length===0)||(state.selectedUsers.selectedArr.length===state.selectedUsers.totalUsers)){
                    state.selectedUsers.isCheckedAll=true
                }else{
                    state.selectedUsers.isCheckedAll=false
                }
            }else if(complete_list_or_searched_list==='searched_list'){
                if((dataItems?.every(item=>state.selectedUsers.selectedArr.includes(item)))&&(!dataItems.some(item=>state.selectedUsers.unselectedArr.includes(item)))||(action.payload[5]===true&&(!dataItems.some(item=>state.selectedUsers.unselectedArr.includes(item))))){
                    state.selectedUsers.isCheckedAll=true
                } else{
                    state.selectedUsers.isCheckedAll=false
                }
            }
            

        },
        selectAllRows:(state,action)=>{
            // if(action.payload[0]===false){
            //     state.selectedUsers.selectedArr=state.selectedUsers.selectedArr.filter(
            //         (element) => !action.payload[1]?.map((item)=>item?._id).includes(element)
            //     );
            //     state.selectedUsers.isCheckedAll=false
            // }
            // else{
            //     const newData = action.payload[1]?.map((item) => item?._id);

            //     // Filter out elements that already exist in state.selectedUsers.selectedArr[index]
            //     const uniqueData = newData.filter((item) => !state.selectedUsers.selectedArr.includes(item));
            //     // state.selectedUsers.selectedArr[index].push(action.payload[1]?.data?.map((item)=>item?.user_id))
            //     state.selectedUsers.selectedArr.push(...uniqueData)
            //     state.selectedUsers.isCheckedAll=true
            // }
            state.selectedUsers.isCheckedAll=action.payload[0]
            const dataItems= action.payload[1]?.map(item=>item._id)
            const searchedItem = action.payload[2]
            if(searchedItem?.trim()===''){
                state.selectedUsers.selectedArr=[]
                state.selectedUsers.unselectedArr=[]
            }else{
                if(action.payload[0]===false){
                    state.selectedUsers.selectedArr?.length>0? state.selectedUsers.selectedArr = state.selectedUsers.selectedArr.filter(item=> !dataItems.includes(item)):''
                    let newArr= new Set([...state.selectedUsers.unselectedArr, ...dataItems])
                    state.selectedUsers.unselectedArr = [...newArr]
                }else if (action.payload[0]===true){
                    let newArr = new Set([...state.selectedUsers.selectedArr, ...dataItems]);
                    state.selectedUsers.selectedArr = [...newArr]
                    state.selectedUsers.unselectedArr?.length>0? state.selectedUsers.unselectedArr = state.selectedUsers.unselectedArr.filter(item=> !dataItems.includes(item)):''
                }
                
            }
           
 
        },
     
        
        searchReducer:(state,action)=>{
            // const allExistMethod1 = action?.payload[0]?.every((item2) =>
            //     state.selectedUsers.selectedArr?.some((item1) => item1 === item2._id)
            // )
            // if(allExistMethod1){
            //     state.selectedUsers.isCheckedAll=true
            // }
            // else{
            //     state.selectedUsers.isCheckedAll=false
            // }
            const dataItems=action?.payload[0]?.map(item=>item._id)
            const selectAllofSearchOrCompleteList = action?.payload[1]
            const selectAllofSearch= action?.payload[2]
            const complete_list_or_searched_list = action?.payload[3]
            if(complete_list_or_searched_list==='complete_list'){
                if((selectAllofSearchOrCompleteList&&state.selectedUsers.unselectedArr.length===0&&action.payload[4]!=='empty')||(state.selectedUsers.selectedArr.length===state.selectedUsers.totalUsers&&action.payload[4]!=='empty')){
                    state.selectedUsers.isCheckedAll=true
                }else{
                    state.selectedUsers.isCheckedAll=false
                }
            }else{
                if((dataItems.every(item => state.selectedUsers.selectedArr.includes(item))||(selectAllofSearchOrCompleteList&&!(dataItems.some(item=>state.selectedUsers.unselectedArr.includes(item)))))){
                    state.selectedUsers.isCheckedAll=true
    
                }else{
                    state.selectedUsers.isCheckedAll=false
                }
            }
            

            
        },
        handleTotalUsers:(state,action) => {
            state.selectedUsers.totalUsers = action.payload[0]
        },
        handleFillFromSearchParamsPatients:(state,action) => {
            state.selectedUsers.selectedArr= action.payload[0]
            state.selectedUsers.unselectedArr=action.payload[1]
        },
       
        resetOrgList:(state)=>{
            state.selectedUsers.selectedArr=[], 
            state.selectedUsers.isCheckedAll=true,
            state.selectedUsers.data=[],
            state.selectedUsers.unselectedArr=[],
            state.selectedUsers.searchVal='',
            state.selectedUsers.totalUsers=0
   

        },
        
        resetTempFilterOpen:(state)=>{
            state.selectedUsers.selectedArr=[], 
            state.selectedUsers.isCheckedAll=true,
            state.selectedUsers.unselectedArr=[]
        },
        handleEmptyDropdown:(state)=>{
            state.selectedUsers.isCheckedAll=false,
            state.selectedUsers.selectedArr=[],
            state.selectedUsers.unselectedArr=[]
        }
       

    }
});

export const {handleEmptyDropdown,handleFillFromSearchParamsPatients, resetTempFilterOpen,resetOrgList,searchReducer,toggleRowSelection,selectAllRows,handleTotalUsers} = wellnessSlice.actions;
export default wellnessSlice.reducer;
